import Scriba from 'react-scriba';

export class DataReservation_Echeancier_Stade {

    static _chargementReservation_Echeancier_Stades = (filtres, sortedColumn, isSortedDescending) => {
        const objet = { filtres, sortedColumn, isSortedDescending };
        const url = "api/Liste/ListeDesReservation_Echeancier_Stades";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onEnregistrementReservation_Echeancier_Stades = (reservation_Echeancier_Stades, recalculerPourcentages) => {
        if (!Array.isArray(reservation_Echeancier_Stades))
            reservation_Echeancier_Stades = [reservation_Echeancier_Stades];

        const objet = { reservation_Echeancier_Stades, recalculerPourcentages };
        const url = "api/MAJDonnees/EnregistrementReservation_Echeancier_Stades";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onSuppressionReservation_Echeancier_Stades = (idOperation, idReservation, idEcheancier, idStade) => {
        const objet = { idOperation, idReservation, idEcheancier, idStade };
        const url = "api/MAJDonnees/SuppressionReservation_Echeancier_Stade";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _onPublipostageDocumentADV = (reservation_Echeancier_Stades, rowGUID, idTypeDocumentOperation, courrierUniqueSiMemeAdresse) => {
        const objet = { reservation_Echeancier_Stades, rowGUID, idTypeDocumentOperation, courrierUniqueSiMemeAdresse };
        const url = "api/Download/PubliposterDocumentADV";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

}